import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"]
  static values = { checked: Boolean, checkedId: String }

  toggle(event) {
    const currentInput = event.currentTarget

    if (this.checkedValue) {
      if (this.checkedIdValue === currentInput.id) {
        this.setInputValue(currentInput, false)
      } else {
        this.clearTargets()
        this.setInputValue(currentInput, true)
      }
    } else {
      this.setInputValue(currentInput, true)
    }
  }

  setInputValue(input, value) {
    input.checked = value
    this.checkedValue = value
    if (value) {
      this.checkedIdValue = input.id
    } else {
      this.checkedIdValue = ""
    }
  }

  clearTargets() {
    this.inputTargets.forEach((input) => {
      input.checked = false
    })
  }

  checkedValueChanged(value) {
    const event = new CustomEvent("toggle-radio-value-changed", { detail: value })
    this.element.dispatchEvent(event)
  }
}
